var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _rect6, _circle2, _rect7, _circle3, _rect8, _circle4, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 244,
    viewBox: "0 0 383 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0228,
    y: 0.410988,
    width: 381.566,
    height: 243.178,
    rx: 3.6989,
    fill: "#F9F9F9",
    stroke: "#E5E5E5",
    strokeWidth: 0.821977
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 254.951,
    y: 6.04883,
    width: 120.992,
    height: 231.901,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 269.066,
    y: 76.627,
    width: 92.7603,
    height: 7.05785,
    fill: "#EFEFEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 269.066,
    y: 87.7168,
    width: 60.4959,
    height: 7.05785,
    fill: "#EFEFEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 281.166,
    y: 113.934,
    width: 80.6612,
    height: 7.05785,
    fill: "#EFEFEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 273.604,
    cy: 117.463,
    r: 4.53719,
    fill: "#EFEFEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 281.166,
    y: 129.059,
    width: 80.6612,
    height: 7.05785,
    fill: "#EFEFEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.604,
    cy: 132.588,
    r: 4.53719,
    fill: "#EFEFEF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 281.166,
    y: 144.18,
    width: 80.6612,
    height: 7.05785,
    fill: "#EFEFEF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.604,
    cy: 147.709,
    r: 4.53719,
    fill: "#EFEFEF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 281.166,
    y: 159.305,
    width: 80.6612,
    height: 7.05785,
    fill: "#EFEFEF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.604,
    cy: 162.834,
    r: 4.53719,
    fill: "#EFEFEF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90918,
    y: 6.04883,
    width: 249.041,
    height: 231.901,
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewImg);
export default __webpack_public_path__ + "static/media/preview-img.f2924d1e1cb4b402aaf03eae14829301.svg";
export { ForwardRef as ReactComponent };